/* Butta Cult — editorial homepage motion.
   GSAP 3 + ScrollTrigger + Lenis (loaded deferred in layout/butta.liquid, before this file).
   Everything is visible without this script. Reduced motion gets native scrolling and no scroll-driven movement. */
(function () {
  var root = document.querySelector('.bce');
  if (!root) return;

  var html = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var gsap = window.gsap;
  var ST = window.ScrollTrigger;
  var intro = html.classList.contains('bce-pre');
  var done = function () { html.classList.remove('bce-pre'); };

  /* after a signup the page reloads on the form: bring the welcome note into view */
  var welcome = root.querySelector('.bc-welcome');
  if (welcome) {
    welcome.scrollIntoView({ block: 'center' });
    try { welcome.focus({ preventScroll: true }); } catch (e) {}
  }

  /* header: solid after the cover starts moving, tucks away on the way down, returns on the way up */
  var head = root.querySelector('[data-head]');
  var lastY = window.scrollY;
  function onScroll(y) {
    if (!head) return;
    head.classList.toggle('is-solid', y > 24);
    var goingDown = y > lastY + 2;
    var goingUp = y < lastY - 2;
    if (goingDown && y > window.innerHeight * 0.7 && !head.contains(document.activeElement)) head.classList.add('is-hidden');
    else if (goingUp || y < 80) head.classList.remove('is-hidden');
    lastY = y;
  }
  onScroll(lastY);

  /* the theme editor re-renders sections on every change, so it gets the calm, static version */
  var design = window.Shopify && window.Shopify.designMode;

  if (reduce || design || !gsap || !ST) {
    done();
    window.addEventListener('scroll', function () { onScroll(window.scrollY); }, { passive: true });
    return;
  }

  gsap.registerPlugin(ST);
  var q = function (sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); };
  var expo = 'expo.out';

  try {
    /* smooth scroll */
    var lenis = null;
    if (window.Lenis) {
      lenis = new window.Lenis({ duration: 1.2, easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); }, smoothWheel: true });
      lenis.on('scroll', function (e) { ST.update(); onScroll(e && typeof e.scroll === 'number' ? e.scroll : window.scrollY); });
      gsap.ticker.add(function (time) { lenis.raf(time * 1000); });
      gsap.ticker.lagSmoothing(0);
      q('a[href^="#"]:not(.bce-skip)').forEach(function (a) {
        a.addEventListener('click', function (ev) {
          var id = a.getAttribute('href');
          var target = id.length > 1 && document.getElementById(id.slice(1));
          if (!target) return;
          ev.preventDefault();
          lenis.scrollTo(target, { duration: 1.6 });
          if (history.replaceState) history.replaceState(null, '', id);
        });
      });
    } else {
      window.addEventListener('scroll', function () { onScroll(window.scrollY); }, { passive: true });
    }

    /* 01 cover: the photo settles, the headline rises out of its line masks */
    var hero = root.querySelector('.bce-hero');
    var heroImg = root.querySelector('.bce-hero__img');
    var lines = q('.bce-line__in');
    var heroBits = q('[data-hero]');
    var cover = root.querySelector('[data-hero-cover]');
    if (intro) {
      gsap.set(lines, { yPercent: 108, opacity: 1 });
      gsap.set(heroBits, { y: 22, opacity: 0 });
      if (cover) gsap.set(cover, { clipPath: 'inset(100% 0% 0% 0%)', opacity: 1 });
      done();
      var tl = gsap.timeline({ defaults: { ease: expo } });
      if (heroImg) tl.fromTo(heroImg, { scale: 1.14, opacity: 0.001 }, { scale: 1, opacity: 1, duration: 2.6 }, 0);
      tl.to(lines, { yPercent: 0, duration: 1.5, stagger: 0.11 }, 0.25)
        .to(heroBits, { y: 0, opacity: 1, duration: 1.3, stagger: 0.1, clearProps: 'transform' }, 0.75);
      if (cover) tl.to(cover, { clipPath: 'inset(0% 0% 0% 0%)', duration: 1.6, ease: 'expo.inOut' }, 0.6);
    } else {
      done();
    }
    if (hero) {
      gsap.to('[data-hero-media]', { yPercent: 9, ease: 'none', scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true } });
      gsap.to('.bce-hero__inner', { y: -70, ease: 'none', scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true } });
    }

    /* 02 manifesto: words come into focus as you read */
    var man = root.querySelector('[data-manifesto]');
    if (man) {
      var pieces = [];
      var split = function (node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (child) {
          if (child.nodeType === 3) {
            var parts = child.textContent.split(/(\s+)/);
            var frag = document.createDocumentFragment();
            parts.forEach(function (part) {
              if (!part) return;
              if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
              var w = document.createElement('span');
              w.className = 'bce-w';
              w.textContent = part;
              frag.appendChild(w);
              pieces.push(w);
            });
            child.replaceWith(frag);
          } else if (child.nodeType === 1 && child.classList.contains('bce-pillimg')) {
            pieces.push(child);
          } else if (child.nodeType === 1) {
            split(child);
          }
        });
      };
      split(man);
      gsap.fromTo(pieces, { opacity: 0.16 }, {
        opacity: 1, ease: 'none', stagger: 0.12,
        scrollTrigger: { trigger: man, start: 'top 82%', end: 'bottom 48%', scrub: 0.6 }
      });
      q('.bce-pillimg img', man).forEach(function (img) {
        gsap.fromTo(img, { scale: 1.5 }, { scale: 1, ease: 'none', scrollTrigger: { trigger: man, start: 'top 85%', end: 'bottom 50%', scrub: true } });
      });
    }

    var mm = gsap.matchMedia();

    /* 03 the barrier butta: the second photo wipes up over the first while the copy scrolls past */
    var drop = root.querySelector('.bce-drop');
    mm.add('(min-width: 900px)', function () {
      if (!drop) return;
      var a = drop.querySelector('.bce-drop__a');
      var b = drop.querySelector('[data-drop-reveal]');
      if (b) {
        gsap.fromTo(b, { clipPath: 'inset(100% 0% 0% 0%)' }, {
          clipPath: 'inset(0% 0% 0% 0%)', ease: 'none',
          scrollTrigger: { trigger: drop, start: 'top top', end: 'bottom bottom', scrub: 0.8 }
        });
      }
      if (a) gsap.fromTo(a, { scale: 1 }, { scale: 1.12, ease: 'none', scrollTrigger: { trigger: drop, start: 'top bottom', end: 'bottom top', scrub: true } });
    });
    var notes = q('[data-note]');
    if (notes.length) {
      gsap.set(notes, { opacity: 0, x: -18 });
      ST.create({ trigger: notes[0].parentNode, start: 'top 85%', once: true, onEnter: function () {
        gsap.to(notes, { opacity: 1, x: 0, duration: 1.1, ease: expo, stagger: 0.13 });
      } });
    }

    /* 04 texture study: pinned and scrubbed sideways on desktop, swipeable on phones */
    var strip = root.querySelector('[data-strip]');
    mm.add('(min-width: 900px)', function () {
      if (!strip) return;
      var track = strip.querySelector('[data-strip-track]');
      strip.classList.add('is-pinned');
      var dist = function () { return Math.max(0, track.scrollWidth - window.innerWidth); };
      var move = gsap.to(track, {
        x: function () { return -dist(); }, ease: 'none',
        scrollTrigger: { trigger: strip, start: 'top top', end: function () { return '+=' + dist(); }, pin: true, scrub: 1, invalidateOnRefresh: true, anticipatePin: 1 }
      });
      q('[data-strip-img]', strip).forEach(function (img) {
        gsap.fromTo(img, { xPercent: -5 }, {
          xPercent: 5, ease: 'none',
          scrollTrigger: { trigger: img.parentNode, containerAnimation: move, start: 'left right', end: 'right left', scrub: true }
        });
      });
      return function () { strip.classList.remove('is-pinned'); };
    });

    /* 05 commandments: each line slides in; on desktop a photo follows the cursor */
    var ruleEls = q('[data-rule]');
    gsap.set(ruleEls, { opacity: 0, y: 34 });
    ST.batch(ruleEls, {
      start: 'top 92%', once: true,
      onEnter: function (batch) { gsap.to(batch, { opacity: 1, y: 0, duration: 1.3, ease: expo, stagger: 0.1, clearProps: 'transform' }); }
    });
    var float = root.querySelector('[data-float]');
    var list = root.querySelector('.bce-rules__list');
    if (fine && float && list) {
      var fimg = float.querySelector('img');
      var xTo = gsap.quickTo(float, 'x', { duration: 0.7, ease: 'power3' });
      var yTo = gsap.quickTo(float, 'y', { duration: 0.7, ease: 'power3' });
      var rTo = gsap.quickTo(float, 'rotation', { duration: 0.9, ease: 'power3' });
      var lastX = 0;
      var preloaded = false;
      var showing = false;
      gsap.set(float, { xPercent: -50, yPercent: -50, scale: 0.86 });
      list.addEventListener('pointerenter', function () {
        if (preloaded) return;
        preloaded = true;
        q('[data-rule-img]', list).forEach(function (r) { var i = new Image(); i.src = r.getAttribute('data-rule-img'); });
      });
      var offset = function () { return float.offsetWidth / 2 + 56; };
      list.addEventListener('pointermove', function (e) {
        xTo(e.clientX + offset());
        yTo(e.clientY);
        rTo(gsap.utils.clamp(-7, 7, (e.clientX - lastX) * 0.6));
        lastX = e.clientX;
      });
      q('[data-rule]', list).forEach(function (rule) {
        rule.addEventListener('pointerenter', function (e) {
          var src = rule.getAttribute('data-rule-img');
          if (!src) return;
          if (fimg.getAttribute('src') !== src) fimg.setAttribute('src', src);
          if (!showing) {
            gsap.set(float, { x: e.clientX + offset(), y: e.clientY });
            showing = true;
          }
          gsap.to(float, { autoAlpha: 1, scale: 1, duration: 0.6, ease: expo, overwrite: 'auto' });
          gsap.fromTo(fimg, { scale: 1.18 }, { scale: 1, duration: 0.9, ease: expo, overwrite: 'auto' });
        });
      });
      list.addEventListener('pointerleave', function () {
        showing = false;
        gsap.to(float, { autoAlpha: 0, scale: 0.86, duration: 0.45, ease: 'power2.out', overwrite: 'auto' });
      });
    }

    /* 06 members: photos unmask, then drift at slightly different speeds */
    q('.bce-member__img').forEach(function (box) {
      var img = box.querySelector('img');
      gsap.set(box, { clipPath: 'inset(14% 10% 14% 10%)' });
      if (img) gsap.set(img, { scale: 1.22 });
      ST.create({ trigger: box, start: 'top 88%', once: true, onEnter: function () {
        gsap.to(box, { clipPath: 'inset(0% 0% 0% 0%)', duration: 1.6, ease: 'expo.inOut' });
        if (img) gsap.to(img, { scale: 1, duration: 1.9, ease: expo });
      } });
    });
    mm.add('(min-width: 900px)', function () {
      q('[data-speed]').forEach(function (fig) {
        var amt = (parseFloat(fig.getAttribute('data-speed')) - 1) * 420;
        gsap.fromTo(fig, { y: amt }, { y: -amt, ease: 'none', scrollTrigger: { trigger: fig, start: 'top bottom', end: 'bottom top', scrub: true } });
      });
    });

    /* 08 the oath: the photo slowly settles behind the copy */
    var oath = root.querySelector('.bce-oath');
    if (oath) {
      gsap.fromTo('[data-oath-media]', { yPercent: -5, scale: 1.12 }, {
        yPercent: 5, scale: 1, ease: 'none',
        scrollTrigger: { trigger: oath, start: 'top bottom', end: 'bottom top', scrub: true }
      });
    }

    /* headings and copy: a soft rise, batched so neighbours stagger */
    var rise = q('[data-rise]');
    gsap.set(rise, { opacity: 0, y: 30 });
    ST.batch(rise, {
      start: 'top 90%', once: true,
      onEnter: function (batch) { gsap.to(batch, { opacity: 1, y: 0, duration: 1.25, ease: expo, stagger: 0.09, clearProps: 'transform' }); }
    });

    /* layout settles once fonts and photos arrive */
    var refresh = function () { ST.refresh(); };
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(refresh);
    window.addEventListener('load', refresh);
  } catch (err) {
    if (window.console) console.warn('[butta] motion off:', err);
    try { ST.getAll().forEach(function (s) { s.kill(); }); } catch (e) {}
    gsap.set(q('.bce-line__in, [data-hero], [data-hero-cover], [data-rise], [data-note], [data-rule], .bce-member__img, .bce-member__img img, .bce-w, .bce-hero__img'), { clearProps: 'all' });
    done();
  }
})();
